/* eslint-disable import/no-anonymous-default-export */
import axios from "axios";
import { API_ENDPOINTS } from "../../Constants";

export default {
  getBookingList: (params) => {
    return axios.get(API_ENDPOINTS.GET_BOOKINGS_LIST, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
        "x-tenant-slug": "default",
      },
      params,
    });
  },
  createBooking: (data) => {
    return axios.post(API_ENDPOINTS.GET_BOOKINGS_LIST, data, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
        "x-tenant-slug": "default",
      },
    });
  },
  getBookingById: (id) => {
    return axios.get(`${API_ENDPOINTS.GET_BOOKINGS_LIST}/${id}`, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
        "x-tenant-slug": "default",
      },
    });
  },
  updateBooking: (id, data) => {
    return axios.patch(`${API_ENDPOINTS.GET_BOOKINGS_LIST}/${id}`, data, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
        "x-tenant-slug": "default",
      },
    });
  },
  deleteBooking: (id) => {
    return axios.delete(`${API_ENDPOINTS.GET_BOOKINGS_LIST}/${id}`, {
      headers: {
        isAuthRequired: true,
        "Content-Type": "application/json",
        "x-tenant-slug": "default",
      },
    });
  },
};
